import {BaseModel} from '../models/base-model.model';

export abstract class BaseConverter<M extends BaseModel, D> {

  constructor() {
  }

  public abstract convertToModel(dto: D): M;

  public abstract convertToDto(model: M): D;

  public convertToModelList(dtoArray: D[]): M[] {
    if (!dtoArray) {
      return null;
    }
    const array: M[] = [];
    for (const dto of dtoArray) {
      if (dto != null) {
        array.push(this.convertToModel(dto));
      }
    }
    return array;
  }

  public convertToDtoList(modelArray: M[], light?: boolean): D[] {
    if (!modelArray) {
      return null;
    }
    const array: any = [];
    for (const model of modelArray) {
      if (model != null) {
        if (light) {
          array.push({id: model.id});
        } else {
          array.push(this.convertToDto(model));
        }
      }
    }

    return array;
  }
}
